import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { INVOICE_SUBTYPES } from 'Utils/constants';
import OutlineLock from '../OutlineIcons/OutlineLock';
import Tooltip from 'Components/Molecules/Tooltip/Tooltip';

export default function InvoiceTitle({ invoice }) {
    const { t } = useTranslation('common');

    const subtypeTitleMap = {
        [INVOICE_SUBTYPES.STANDARD]: t('invoice-standard'),
        [INVOICE_SUBTYPES.STANDARD_CORRECTIVE]: t('invoice-standard-corrective'),
        [INVOICE_SUBTYPES.SIMPLIFIED]: t('invoice-simplified'),
        [INVOICE_SUBTYPES.SIMPLIFIED_CORRECTIVE]: t('invoice-simplified-corrective'),
        [INVOICE_SUBTYPES.QUOTE]: t('invoice-quote'),
        [INVOICE_SUBTYPES.PROFORMA]: t('invoice-proforma'),
        [INVOICE_SUBTYPES.DELIVERY_NOTE]: t('invoice-delivery-note'),
    };

    if (invoice.tax_authority_provider_status === 'issued') {
        return (
            <div className="inline-flex align-middle items-center gap-2">
                <Tooltip
                    label={t('invoice-issued-lock-tooltip')}
                >
                    <div className="p-1.5 rounded bg-primary/10 text-primary">
                        <OutlineLock size={12} strokeWidth={2} />
                    </div>
                </Tooltip>
                {subtypeTitleMap[invoice?.subtype] ?? t('invoice-standard')}
            </div>
        );
    }

    return subtypeTitleMap[invoice?.subtype] ?? t('invoice-standard');
}

InvoiceTitle.propTypes = {
    invoice: PropTypes.shape({ subtype: PropTypes.string, tax_authority_provider_status: PropTypes.string }).isRequired,
};
